import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { CardServiceService } from '../Services/card-service.service';
import { FiledsService } from '../Services/fileds.service';

@Component({
  selector: 'app-card-limit-decline.component',
  templateUrl: './card-limit-decline.component.html',
  standalone:false,
  styleUrls: ['./card-limit-decline.component.scss']
})
export class CardLimitDeclineComponent implements OnInit {
  DeclineList: any;
  selectedDecline: string = '';
  selectDeclinecode: any;
  selectDeclineobj: any;

  constructor(public common: CommonService, private location: Location, public auth: AuthService, private field: FiledsService, public _router: Router, public cardService: CardServiceService,) { }

  async ngOnInit(): Promise<any> {

    this.auth.accessToken = await this.common.Get("token");
    await this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data?.response?.code == 1) {
        await this.field.ListFieldValues("DECLINE", "string", this.auth.accessToken).then((res: any) => {

          console.log('DeclineReasonList', res)
          if (res?.response?.code == 1) {

            this.DeclineList = res.response.content.list.list.map((x) => ({ value: x.value, displayValue: x.description, code: x.genericId }));
    

            console.log('DeclineList', this.DeclineList)
          }
          else {
            this.common.ParseErrorAlert('', "OK", this._router, res)
          }
        })
      } 
      else {
        await this.common.hideLoading();

        this.common.ParseErrorAlert("", "", this._router, data);
      }
    })

   

  }

  back() {
    this.location.back();
  }

  onDeclineChange(e) {

    console.log('e', e)
    this.selectedDecline = e.displayValue
    this.selectDeclineobj = this.DeclineList.filter(x => x.displayValue == this.selectedDecline)
    this.selectDeclinecode = JSON.stringify(this.selectDeclineobj[0].code)

  }


  async DeclineLimit() {

    this.common.presentLoading();
  await this.cardService.DeclineCardLimit(this.cardService.AutoTempLimitObj.limitRequestId, this.selectDeclinecode, this.selectedDecline, "", this.auth.accessToken).then((data: any) => {

      if (data?.response?.code == 1) {

        this.common.hideLoading();
        this.DeclineLimit = data.response.content;

        console.log('this.DeclineLimit', this.DeclineLimit);
        this._router.navigate(["/CardLimitSuccess"], { queryParams: { Decline: true } })
      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert('', 'OK', this._router, data);
      }
    })
  }

}


